import { ScrollBoxOptions } from "@pixi/ui";
import { UIScrollBox } from "../../../../common/components/UIScrollBox";

export class MarketplaceScrollBox extends UIScrollBox {
    public constructor(options: ScrollBoxOptions) {
        super(options);
    }

    public layout(): void {
        for (let i = 0; i < this.items.length; i++) {
            const item = this.items[i];
            item.position.x = item.x + item.width * 0.5;
            item.position.y = this.height * 0.5;
        }
    }
}